export default __webpack_public_path__ + "static/media/doselect-logo-inverted.183bfeaa.svg";